import { Component, Input, OnInit } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { SnackbarService } from '@app/core/services/snackbar.service';
import { OverlayService } from '@app/shared/components/overlay/overlay.service';
import { GridDataResult, PageChangeEvent } from '@progress/kendo-angular-grid';
import { defer, forkJoin, Observable } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { EmploymentRecordOtherCompensation } from './models/employment-record-other-compensation.model';
import { EmploymentRecordOtherCompensationsService } from './services/employment-record-other-compensations.service';
import { EmploymentRecordOtherCompensationDialogComponent } from './components/employment-record-other-compensation-dialog/employment-record-other-compensation-dialog.component';

@Component({
  selector: 'app-employment-record-other-compensations',
  templateUrl: './employment-record-other-compensations.component.html',
  styleUrls: ['./employment-record-other-compensations.component.scss']
})
export class EmploymentRecordOtherCompensationsComponent implements OnInit {
  @Input() employeeId: string;
  @Input() employmentRecordId: string;
  public columns: any[] = [
    { field: "compensationType", subField: "text", title: "Compensation Type", type: "navigation" },
    { field: "startDate", title: "Start Date", type: "date" },
    { field: "endDate", title: "End Date", type: "date" },
    { field: "paymentCycle", subField: "text", title: "Payment Cycle" },
    { field: "currency", subField: "text", title: "Currency" },
    { field: "amount", title: "Amount" },
    { field: "percentage", title: "Percentage" },
  ];
  public bindingType: String = "array";
  public view: Observable<GridDataResult>;
  public gridData: any;
  public gridDataResult: GridDataResult;
  isLoading: boolean;
  pageSize: number = 5;
  skip: number = 0;

  constructor(
    private dialog: MatDialog,
    private overlayService: OverlayService,
    private snackbarService: SnackbarService,
    private employmentRecordOtherCompensationsService: EmploymentRecordOtherCompensationsService
  ) {}

  ngOnInit(): void {
    this.view = this.employmentRecordOtherCompensationsService.getOtherCompensations(this.employeeId, this.employmentRecordId);
    this.getOtherCompensations();
  }

  getOtherCompensations(): void {
    this.isLoading = true;

    this.employmentRecordOtherCompensationsService.getOtherCompensations(this.employeeId, this.employmentRecordId, this.pageSize, this.skip)
    .pipe(
        finalize(()=>{ this.isLoading = false; })
    )
    .subscribe(
      res => {
        this.gridDataResult = {
          data: res.otherCompensations,
          total: res.pagination.TotalCount,
        }
        this.gridData = res.employmentRecords;
      }
    )
  }

  openEmploymentRecordOtherCompensationDialog(employmentRecordOtherCompensation?: EmploymentRecordOtherCompensation) {
    const dialogConfig = new MatDialogConfig();

    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = true;

    dialogConfig.data = {
      employmentRecordId: this.employmentRecordId,
      employeeId: this.employeeId,
      OtherCompensationId: employmentRecordOtherCompensation ? employmentRecordOtherCompensation.id : null
    };

    const dialogRef = this.dialog.open(EmploymentRecordOtherCompensationDialogComponent, dialogConfig);
    dialogRef.afterClosed().subscribe(
      data => {
        if (data === true) {
          this.getOtherCompensations();
        }
      }
    );
  }

  deleteEmploymentRecordCompensation(employmentRecordOtherCompensationIds: string[]) {
    const observables = employmentRecordOtherCompensationIds.map(selectedItem => defer(() => this.employmentRecordOtherCompensationsService.deleteOtherCompensation(this.employeeId, this.employmentRecordId,selectedItem)));

    this.overlayService.show();

    forkJoin(observables)
    .pipe(
      finalize(() => this.overlayService.hide())
    )
    .subscribe(
      (res) => {
        this.getOtherCompensations();
        this.snackbarService.openSnackBar('Deleted successfully', 'clear', 'success');
      },
      err => {
        this.snackbarService.openSnackBar(err, 'clear', 'warn');
      }
    );
  }

  public pageChange(event: PageChangeEvent): void {
    this.skip = event.skip;
    this.pageSize = event.take
    this.getOtherCompensations();
  }

}

